import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../../../redux/actions/CartActions";
import FormalityHeader from "../../../components/header/FormalityHeader";
import { eneoRequest } from "../../../redux/actions/FormalityActions";
import Swal from "sweetalert2";
import Loader from "../../../components/loader/Loader";
import "../../styles/flow-form.css";

const protectionOptions = [
  {
    label: "Prépayé",
    value: "prepaid",
    price: 100000,
  },
  {
    label: "Postpayé",
    value: "postpaid",
    price: 120000,
  },
];

function EneoElectricityMeterType() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cart);
  const { user } = useSelector((state) => state.authUser);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  // Handle option selection
  const handleOptionSelect = async (option) => {
    setSubmitting(true);

    await dispatch(
      addToCart({
        price: option.price,
      })
    );

    await dispatch(
      eneoRequest(
        user.token,
        {
          country: cart.country,
          serviceType: option.value,
        },
        handleCallback
      )
    );
  };

  const handleCallback = ({ success, message }) => {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 4000,
    });
    if (success) {
      navigate("/formality-documents");
    } else {
      Toast.fire({
        icon: "error",
        title: "Échec",
        text: message,
      });
    }
    setSubmitting(false);
  };

  return (
    <div className="legacy-flow">
      <FormalityHeader from={cart.from} />
      <Loader isLoading={submitting} />

      {/* Title Section */}

      <div className="container mt-4 text-center" style={{ maxWidth: "800px" }}>
        <h4 className="text-2xl font-semibold">
          Quel type de <span style={{ color: "#FF5500" }}>compteur</span>{" "}
          souhaitez-vous installer ?
        </h4>
      </div>

      {/* Option Selection Boxes */}
      <div className="container mt-4 d-flex justify-content-center">
        <div className="row w-100" style={{ maxWidth: "600px" }}>
          {protectionOptions.map((option, index) => (
            <div className="col-lg-6 mb-4" key={index}>
              <div
                className="option-box d-flex align-items-center justify-content-center flex-column"
                onClick={() => handleOptionSelect(option)}
                style={{
                  height: "200px",
                  border: "2px solid #ddd",
                  borderRadius: "8px",
                  padding: "20px",
                  cursor: "pointer",
                  transition: "border-color 0.3s",
                  textAlign: "center",
                  color: "#000",
                  position: "relative",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.borderColor = "#FF5500")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.borderColor = "#ddd")
                }
              >
                <span style={{ fontSize: "1.1rem", fontWeight: "bold" }}>
                  {option.label}

                  <div
                    style={{
                      fontSize: "0.9rem",
                      textAlign: "center",
                    }}
                  >
                    <span style={{ color: "#FF5500", fontWeight: "400" }}>
                      {option.price.toLocaleString()} FCFA
                    </span>
                  </div>
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default EneoElectricityMeterType;
